<template>
    <div>
        <div
            class="apprentice-simple-card"
            v-if="roadmapIn">
            <design-2021-roadmap-status-component
                :steps-in="roadmapIn.steps"
                :title="
                    groupIn.roadmap_name && groupIn.roadmap_name.length > 0
                        ? groupIn.roadmap_name
                        : $t('roadmap.roadmap')
                "
                :project-id-in="projectId">
            </design-2021-roadmap-status-component>
        </div>

        <section>
            <div class="paper-overview row">
                <div class="col-12 col-md-6 col-xl-4">
                    <div class="documents apprentice-simple-card">
                        <div class="component-title">
                            <h3 class="title">{{ $t('roadmap.documents') }}</h3>
                        </div>
                        <div class="paper">
                            <div class="paper-content">
                                <div class="icon"><i class="fas fa-fw fa-file-alt"></i></div>
                                <div class="title">
                                    {{ groupIn.document_name !== null ? groupIn.document_name : $t('roadmap.paper') }}
                                </div>

                                <a
                                    class="clickable"
                                    v-if="!closed || !isStudent"
                                    :href="editUrl"
                                    target="_blank"></a>
                                <a
                                    class="clickable"
                                    v-else-if="
                                        !projectIn.closes_at &&
                                        editorfileIn !== 0 &&
                                        editorfileIn.editor_type !== 'gd' &&
                                        editorfileIn.editor_type !== 'mg' &&
                                        editorfileIn.editor_type !== 'sp'
                                    "
                                    :href="readUrl"
                                    target="_blank">
                                </a>
                            </div>

                            <design-2021-paper-show-paper-buttons-component
                                :read-url="readUrl"
                                :edit-url="editUrl"
                                :project-in="projectIn"
                                :editor-file-in="editorfileIn"
                                :download-url="downloadUrl"
                                :versions-in="versionsIn"
                                :is-student="isStudent">
                            </design-2021-paper-show-paper-buttons-component>
                        </div>

                        <div
                            class="plan-of-action"
                            v-if="groupIn.actionplan">
                            <div class="plan-of-action-content">
                                <div class="icon"><i class="fas fa-fw fa-file-contract"></i></div>
                                <div class="title">
                                    {{
                                        groupIn.actionplan_name !== null
                                            ? groupIn.actionplan_name
                                            : $t('roadmap.plan_of_approach')
                                    }}
                                </div>
                                <a
                                    class="clickable"
                                    :href="editActionPlanUrl"
                                    target="_blank"></a>
                            </div>

                            <design-2021-paper-show-action-plan-buttons-component
                                :read-action-plan-url="readActionPlanUrl"
                                :edit-action-plan-url="editActionPlanUrl"
                                :action-plan-editor-file-in="actionPlanEditorFileIn"
                                :editor-file-in="editorfileIn"
                                :download-actionplan-url="downloadActionPlanUrl"
                                :project-in="projectIn"
                                :action-plan-versions-in="actionPlanVersionsIn">
                            </design-2021-paper-show-action-plan-buttons-component>
                        </div>

                        <div
                            class="custom-editor-file"
                            v-if="groupIn.custom_editor_files"
                            v-for="custom_editor_file in groupIn.group_custom_editor_files">
                            <div :class="getCustomEditorFileClass(custom_editor_file)">
                                <div class="icon"><i :class="'fas fa-fw ' + getIcon(custom_editor_file)"></i></div>
                                <div class="title">
                                    {{ custom_editor_file.name }}
                                </div>
                                <a
                                    class="clickable"
                                    :href="customEditorFileUrl(custom_editor_file)"
                                    target="_blank"></a>
                            </div>

                            <design-2021-project-show-custom-editor-file-buttons-component
                                :project-in="projectIn"
                                :group-custom-editor-file-in="custom_editor_file">
                            </design-2021-project-show-custom-editor-file-buttons-component>
                        </div>

                        <div
                            class="powerpoint"
                            v-if="groupIn.powerpoint">
                            <div class="powerpoint-content">
                                <div class="icon"><i class="fas fa-fw fa-presentation"></i></div>
                                <div class="title">
                                    {{ groupIn.powerpoint_name !== null ? groupIn.powerpoint_name : 'Powerpoint' }}
                                </div>
                                <a
                                    class="clickable"
                                    :href="editPowerpointUrl"
                                    target="_blank"></a>
                            </div>

                            <design-2021-paper-show-powerpoint-buttons-component
                                :edit-presentation-url="editPowerpointUrl"
                                :download-presentation-url="downloadPresentationUrl"
                                :presentation-editor-file-in="presentationeditorfileIn"
                                :project-in="projectIn"
                                :editor-file-in="editorfileIn"
                                :power-point-versions-in="powerPointVersionsIn">
                            </design-2021-paper-show-powerpoint-buttons-component>
                        </div>

                        <div
                            class="magazine"
                            v-if="groupIn.magazine">
                            <div class="magazine-content">
                                <div class="icon"><i class="fas fa-fw fa-book-open"></i></div>
                                <div class="title">
                                    {{ groupIn.magazine_name !== null ? groupIn.magazine_name : 'Magazine' }}
                                </div>
                                <a
                                    class="clickable"
                                    :href="editMagazine()"
                                    target="_blank"></a>
                            </div>

                            <div class="management">
                                <b-button
                                    class="btn-open-magazine"
                                    :v-b-tooltip="$t('common.open')"
                                    variant="primary-icon-only"
                                    target="_blank"
                                    :href="editMagazine()">
                                    <i class="fas fa-folder-open fa-fw"></i>
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-md-6 col-xl-4">
                    <div class="appointments apprentice-simple-card">
                        <div class="component-title">
                            <h3 class="title">{{ $t('roadmap.appointment') }}</h3>
                            <b-button
                                class="btn-show-all btn-link-type"
                                variant="primary"
                                @click.prevent.stop()="showcalendar">
                                {{ $t('roadmap.show_all') }}
                            </b-button>
                        </div>

                        <div
                            class="apprentice-appointments-widget appointments-list"
                            v-if="recentCalendarItems.length">
                            <div
                                class="appointment-item"
                                v-for="(item, itemKey) of recentCalendarItems"
                                :key="`${item.title}-${itemKey}`">
                                <div class="header">
                                    <div class="title">{{ item.title }}</div>
                                    <div class="type">
                                        <i :class="'fad fa-fw ' + getIconType(item)"></i>
                                    </div>
                                </div>
                                <div class="date">
                                    {{ item.date | date_named_month_short }}
                                </div>
                            </div>
                        </div>

                        <div
                            class="empty-appointments-list"
                            v-else>
                            <b-alert
                                show
                                variant="info"
                                >{{ $t('roadmap.there_are_no_appointments') }}
                            </b-alert>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-md-6 col-xl-4">
                    <div class="messages apprentice-simple-card">
                        <div class="component-title">
                            <h3 class="title">{{ $t('roadmap.messages') }}</h3>
                            <b-button
                                class="btn-show-all btn-link-type"
                                v-if="messages.length"
                                variant="primary"
                                @click.prevent.stop()="showMessages">
                                {{ $t('roadmap.show_all') }}
                            </b-button>
                        </div>

                        <design-2021-apprentice-message-history-component
                            v-if="messages.length"
                            :messages-in="messages.slice(0, 3)"
                            message-type="project"
                            :widget-mode="true">
                        </design-2021-apprentice-message-history-component>

                        <div
                            class="empty-message"
                            v-else>
                            <b-alert
                                show
                                variant="info"
                                >{{ $t('roadmap.no_messages_found') }}
                            </b-alert>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import moment from 'moment';
import Design2021PaperShowActionPlanButtonsComponent from '../../../paper/buttons/design-2021-paper-show-action-plan-buttons-component.vue';
import Design2021PaperShowPaperButtonsComponent from '../../../paper/buttons/design-2021-paper-show-paper-buttons-component.vue';
import Design2021RoadmapStatusComponent from '../common/design-2021-roadmap-status-component.vue';
import Design2021PaperShowPowerpointButtonsComponent from '../../../paper/buttons/design-2021-paper-show-powerpoint-buttons-component.vue';
import Design2021ApprenticeMessageHistoryComponent from '../../../common/message/design-2021-apprentice-message-history-component.vue';

export default {
    name: 'design-2021-paper-show-progress-component',

    components: {
        Design2021ApprenticeMessageHistoryComponent,
        Design2021PaperShowPowerpointButtonsComponent,
        Design2021RoadmapStatusComponent,
        Design2021PaperShowPaperButtonsComponent,
        Design2021PaperShowActionPlanButtonsComponent,
    },

    props: [
        'roadmapIn',
        'groupIn',
        'projectId',
        'projectIn',
        'editorfileIn',
        'actionPlanEditorFileIn',
        'presentationeditorfileIn',
        'versionsIn',
        'agendaItems',
        'messagesIn',
        'profileImageIn',
        'actionPlanVersionsIn',
        'powerPointVersionsIn',
    ],

    data() {
        return {
            isStudent: !!AuthIsStudent,
            editUrl:
                this.projectIn.type_id == 1
                    ? this.routes.baseUrl() + this.routes.paperEditorEdit(this.projectId)
                    : this.projectIn.magazine
                      ? this.routes.baseUrl() + '/magazine/' + this.projectIn.magazine.id
                      : null,
            editActionPlanUrl: this.routes.baseUrl() + this.routes.paperEditorActionPlanEdit(this.projectId),
            editPowerpointUrl: this.routes.baseUrl() + this.routes.paperEditorPowerpointEdit(this.projectId),
            readUrl: this.routes.baseUrl() + this.routes.paperEditorRead(this.projectId),
            readActionPlanUrl: this.routes.baseUrl() + this.routes.paperEditorActionPlanRead(this.projectId),
            downloadUrl: this.routes.baseUrl() + this.routes.paperEditorDownload(this.projectId),
            downloadActionPlanUrl: this.routes.baseUrl() + this.routes.paperEditorActionPlanDownload(this.projectId),
            downloadPresentationUrl:
                this.routes.baseUrl() + this.routes.paperEditorPresentationDownload(this.projectId),
            calendarItems: this.agendaItems,
            messages: this.messagesIn,
            wordLimit: '',
        };
    },

    computed: {
        recentCalendarItems() {
            if (this.calendarItems.length) {
                let currentDay = moment().startOf('day').format('YYYY-MM-DD');
                let orderedItems = this.calendarItems.filter((item) => {
                    return (
                        moment(item.date).diff(currentDay, 'days') >= 0 ||
                        moment(item.date_end).diff(currentDay, 'days') >= 0
                    );
                });

                return orderedItems.slice(0, 3);
            }
            return [];
        },
        closed() {
            if (this.projectIn.closes_at) {
                const closeDate = new Date(this.projectIn.closes_at).getTime();
                const nowDate = new Date().getTime();

                return closeDate < nowDate;
            } else {
                return false;
            }
        },
    },

    watch: {
        agendaItems: function (value) {
            this.calendarItems = value;
        },
        messagesIn: function (value) {
            this.messages = value;
        },
    },
    methods: {
        customEditorFileUrl(groupCustomEditorFile) {
            return (
                this.routes.baseUrl() +
                this.routes.projectCustomEditorFileEdit(this.projectId, groupCustomEditorFile.id)
            );
        },
        getIcon(customEditorFile) {
            if (customEditorFile.editor_file) {
                let types = {
                    WORD: 'fa-file-alt',
                    PPT: 'fa-presentation',
                    EXCEL: 'fa-spreadsheet',
                };
                return types[customEditorFile.editor_file.file_type];
            }

            return 'fa-file-alt';
        },
        showcalendar() {
            this.$emit('showCalendar');
        },
        showMessages() {
            this.$emit('showMessages');
        },
        editMagazine() {
            return this.routes.paperShow(this.projectIn.id) + '/extramagazine';
        },

        wordCount(message) {
            return message.split(' ').length > 25;
        },

        isalphaNumericChar(rawString) {
            let isAlphaNumericCharacter = false;
            for (let i = 0; i < rawString.length; i++) {
                let charCode = rawString.charCodeAt(i);

                // Check number, letters
                if (
                    (charCode > 47 && charCode < 58) ||
                    (charCode > 64 && charCode < 91) ||
                    (charCode > 96 && charCode < 123)
                ) {
                    isAlphaNumericCharacter = true;
                    return isAlphaNumericCharacter;
                }
            }
            return isAlphaNumericCharacter;
        },

        getIconType(item) {
            const color = item.type ? `text-${item.type.class}` : 'text-warning';

            if (item.type) {
                if (item.type.name.toLocaleLowerCase() === 'deadline') {
                    return `fa-alarm-exclamation ${color}`;
                }
            }

            return `fa-calendar-day ${color}`;
        },

        getMessagePart(message, firstPart) {
            let rawMessage = message;
            if (firstPart) {
                return rawMessage.split(' ').splice(0, 25).join(' ') + ' ...';
            }
            return rawMessage.split(' ').splice(25).join(' ');
        },
        getCustomEditorFileClass(customEditorFile) {
            if (customEditorFile.editor_file) {
                return customEditorFile.editor_file.file_type + '-content';
            }
            return 'WORD-content';
        },
    },
};
</script>

<style scoped lang="scss">
.documents {
    > div:not(.component-title):not(:first-child) {
        padding-top: map-get($grid-gutter-spacing, 'ten');
    }

    > div:not(.component-title):not(:last-child) {
        padding-bottom: map-get($grid-gutter-spacing, 'ten');
        border-bottom: 3px dotted $border-color;
    }
}

.custom-editor-file,
.paper,
.plan-of-action,
.powerpoint,
.magazine {
    display: flex;
    justify-content: flex-start;
    align-content: center;
    font-size: 1.3125rem;

    .WORD-content,
    .PPT-content,
    .EXCEL-content,
    .paper-content,
    .plan-of-action-content,
    .powerpoint-content,
    .magazine-content {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        &:hover {
            cursor: pointer;

            .title {
                font-weight: $font-weight-bold;
            }
        }
    }

    .icon {
        align-self: center;
        padding: 10px;
        background: $secondary-background-color;
        border-radius: $border-radius-content;
        color: $primary;
    }

    .title {
        font-size: $default-font-size;
        font-family: $headings-font-family;
        margin-left: map-get($grid-gutter-spacing, 'ten');
        align-self: center;
    }

    .management {
        align-self: center;
        margin-left: auto;
    }
}

.paper {
    padding-top: 0;
}

.appointment-item {
    i {
        font-size: 1.5625rem;
    }
}

.avatar > span {
    background-color: transparent;
}

.messages ::v-deep {
    .message-block {
        .display-html-content {
            overflow-x: initial;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .paper-overview {
        > div:not(:last-child) {
            margin-bottom: 0;
        }
    }
}
</style>
